import { Flex, Form, Radio, Space } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"
import { useEffect, useRef } from "react"
import { getActiveSetValue, getConditionalRevertValue, shouldRevertConditionalValue } from "../../../utils/formsHelper";
import { useTranslation } from 'react-i18next';

const RadioInput = (props) => {
    const { t } = useTranslation();
    const { label, tooltip, helpText, mandatory, readOnly, options = [], formValues, other, sort, layout, id, form, setValueData, previewMode, highlight=false, ...rest } = props
    // const [radioOptions, setRadioOptions] = useState([])
    const rules = mandatory ? [{ required: true }] : undefined;
    const disabled = previewMode && readOnly ? true : false

    const help = tooltip ? { title: helpText, icon: <QuestionCircleOutlined /> }
        : undefined;
    let selectOptions = (options || []).filter(opt => opt.label)
    if (sort === "ascending") {
        selectOptions.sort((a, b) => a.label.localeCompare(b.label));
    } else if (sort === "descending") {
        selectOptions.sort((a, b) => b.label.localeCompare(a.label));
    }
    if (other) {
        selectOptions.push({ label: t('Other'), value: "Other" })
    }

    // setRadioOptions(selectOptions)

    let activeSetValue = getActiveSetValue(setValueData, true)

    // Track the condition value already applied so an editable field is prefilled
    // only once. Disabled fields stay locked to the condition value.
    const lastAppliedConditionalRef = useRef(undefined)

    useEffect(() => {
        if (activeSetValue?.value) {
            const key = activeSetValue.value
            if (disabled) {
                const current = form?.getFieldValue(id)
                if (current !== key) {
                    form?.setFieldValue(id, key)
                }
            } else if (lastAppliedConditionalRef.current !== key) {
                form?.setFieldValue(id, key)
            }
            lastAppliedConditionalRef.current = key
        } else if (shouldRevertConditionalValue(activeSetValue, { disabled, currentValue: form?.getFieldValue(id), appliedValue: lastAppliedConditionalRef.current })) {
            form?.setFieldValue(id, getConditionalRevertValue(id, props.defaultFormValues))
            lastAppliedConditionalRef.current = undefined
        } else {
            lastAppliedConditionalRef.current = undefined
        }
    }, [activeSetValue, form, id, disabled])

    useEffect(() => {
        if (formValues?.[id] === "Other" && !other) {
            form.resetFields([id])
        }
    }, [formValues, other])

    return (
        <div className="form-element">
            <Flex vertical>
                <Form.Item name={id} tooltip={help} rules={rules} messageVariables={{ label }} className="vertical-group"
                    label={<span
                        style={{
                            color: (highlight && !rest.isPublicForm) ? "#722ed1" : "inherit",
                            fontWeight: (highlight && !rest.isPublicForm) ? 600 : 400,
                            background: (highlight && !rest.isPublicForm) ? "#f5eeff" : "transparent",
                            padding: "2px 6px",
                            borderRadius: 4,
                        }}
                    >
                        {label}
                    </span>}
                >
                    <Radio.Group disabled={disabled}>
                        <Space direction={layout ? "vertical" : "horizontal"} style={{ alignItems: "start" }}>
                            {
                                selectOptions.map(opt => {
                                    return <Radio style={{ textAlign: "left" }} value={opt.value}>{opt.label}</Radio>
                                })
                            }
                        </Space>
                    </Radio.Group>
                </Form.Item>
            </Flex>
        </div>
    )
}

export default RadioInput